import {
	Component,
	OnChanges,
	OnDestroy,
	OnInit,
	SimpleChanges,
	ViewEncapsulation,
	inject,
	input,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
	MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
	MatAutocompleteModule,
} from '@angular/material/autocomplete';
import { first, Subject } from 'rxjs';
import { fuseAnimations } from '@fuse/animations/public-api';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SearchCommandPaletteDialog } from 'app/components/search-command-palette/search-command-palette.component';
import { Overlay } from '@angular/cdk/overlay';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
	selector: 'search',
	templateUrl: './search.component.html',
	encapsulation: ViewEncapsulation.None,
	exportAs: 'fuseSearch',
	animations: fuseAnimations,
	imports: [
		MatButtonModule,
		MatIconModule,
		FormsModule,
		MatAutocompleteModule,
		ReactiveFormsModule,
		MatOptionModule,
		MatFormFieldModule,
		MatInputModule,
	],
	providers: [
		{
			provide: MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
			useFactory: () => {
				const overlay = inject(Overlay);
				return () => overlay.scrollStrategies.block();
			},
		},
	],
	host: {
		'(window:keydown.control.s)': 'searchHotkey($event)',
	},
})
export class SearchComponent implements OnChanges, OnInit, OnDestroy {
	readonly appearance = input<any>(undefined);

	private _unsubscribeAll: Subject<any> = new Subject<any>();

	constructor(private _dialog: MatDialog) {}

	ngOnChanges(changes: SimpleChanges): void {}

	ngOnInit(): void {}

	ngOnDestroy(): void {
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}

	searchHotkey(event: Event) {
		event.preventDefault();
		this.open();
	}

	open() {
		let dialogRef: MatDialogRef<SearchCommandPaletteDialog>;
		let dialogInput: any = {};

		dialogRef = this._dialog.open(SearchCommandPaletteDialog, {
			data: dialogInput,
			width: '48rem',
		});

		dialogRef
			.afterClosed()
			.pipe(first())
			.subscribe({
				next: (value) => {},
			});
	}
}
